import { render, staticRenderFns } from "./WaySetting.vue?vue&type=template&id=2fb1c36d&scoped=true"
import script from "./WaySetting.vue?vue&type=script&lang=js"
export * from "./WaySetting.vue?vue&type=script&lang=js"
import style0 from "./WaySetting.vue?vue&type=style&index=0&id=2fb1c36d&prod&lang=scss&scoped=true"
import style1 from "./WaySetting.vue?vue&type=style&index=1&id=2fb1c36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1c36d",
  null
  
)

export default component.exports